'use client'

import { cn } from '@gyym/ui'
import { useCallback, useId, useState } from 'react'

import { ACTIVITIES } from '../_data'
import { LocationOnIcon } from './icons'
import { Lines, LpModal, ModalPhotoRow } from './LpModal'
import { EASE_OUT_EXPO } from './styles'

/** アクティビティのタイル一覧。クリックで説明モーダルを開く */
export const ActivityTiles = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)
  const labelId = useId()
  const close = useCallback(() => setOpenIndex(null), [])
  const activity = openIndex === null ? null : ACTIVITIES[openIndex]

  return (
    <>
      {ACTIVITIES.map((item, index) => (
        <button
          key={item.image}
          type="button"
          onClick={() => setOpenIndex(index)}
          aria-haspopup="dialog"
          className={cn(
            'm-2 flex size-[250px] max-w-[calc(100%-16px)] flex-col items-center justify-center rounded-[20px] bg-white text-center shadow-[0_2px_10px_#4D5257] max-[540px]:size-[170px]',
            `transition-transform duration-[800ms] ${EASE_OUT_EXPO} hover:translate-y-[-15px]`,
          )}
        >
          <span className="relative flex size-[235px] flex-col items-center justify-center overflow-hidden rounded-[10px] max-[540px]:size-[160px] max-[540px]:rounded-xl">
            <span
              className="absolute inset-0 bg-cover bg-center brightness-[0.7]"
              style={{ backgroundImage: `url(${item.image})` }}
            />
            <span className="relative block text-center font-josefin-sans text-[20px] font-semibold leading-7 tracking-[3px] text-white max-[540px]:text-[14px] max-[540px]:leading-[19.6px] max-[540px]:tracking-[2.1px]">
              <Lines lines={item.label} />
            </span>
          </span>
        </button>
      ))}

      <LpModal open={activity !== null} onClose={close} labelId={labelId}>
        {activity && (
          <>
            <p className="mt-5 text-center font-josefin-sans text-[16px] font-normal leading-[22.4px] text-[#EEEEEE]">
              {activity.modal.title}
            </p>
            <p
              id={labelId}
              className="mb-5 text-center text-[16px] font-medium leading-[22.4px] text-[#EEEEEE]"
            >
              {activity.modal.heading}
            </p>
            <p className="mx-[15px] max-w-[calc(100%-30px)] text-center text-[14px] font-normal leading-[23.8px] text-[#EEEEEE]">
              <Lines lines={activity.modal.body} />
            </p>
            <p className="mb-5 mt-[30px] text-center text-[14px] font-medium leading-[19.6px] text-white">
              【GYYMで利用できる施設の例】
            </p>
            <ModalPhotoRow
              photo={activity.modal.photo}
              photoPosition={activity.modal.photoPosition}
              logo={activity.modal.logo}
              className="mb-[5px]"
            />
            <div className="mb-5 flex w-[calc(100%-30px)] items-start">
              <LocationOnIcon className="size-4 shrink-0 text-[#EEEEEE]" />
              <p className="w-full text-center font-lato text-[12px] font-normal leading-[16.8px] tracking-[1.2px] text-[#EEEEEE]">
                {activity.modal.locations}
              </p>
            </div>
          </>
        )}
      </LpModal>
    </>
  )
}
